import React from 'react';
import ReactDOM from "react-dom/client";
// Use the HashRouter rather than the default BrowserRouter. To make the
// browser router work, I need to configure the Apache server to serve
// "index.html" for all routes, except the static data, in order to allow for
// direct linking. I might do that later.
import { HashRouter } from "react-router";

import Router from './Router';

ReactDOM.createRoot(document.getElementById("root")).render(
  <HashRouter>
    <Router />
  </HashRouter>,
);
